module.exports = "pegasus/assets/theme5/facebook-icon-1.png";